import { isFieldError } from "../helpers";

import Input from "../components/Input";
import RadiosScale from "../components/RadiosScale";

export default function Q1Fields({ handleUpdate, errors }) {
	return (
		<>
			<h4 style={{ fontSize: "1.15rem" }}>1. Overall Experience</h4>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="1.1. Overall, how satisfied were you with your experience using the dashboard to support your attendees?"
					reqd={true}
					data={[
						{
							name: "q1_1",
							val: "1",
							label: "1 - Poor",
						},
						{
							name: "q1_1",
							val: "2",
							label: "2 - Fair",
						},
						{
							name: "q1_1",
							val: "3",
							label: "3 - Good",
						},
						{
							name: "q1_1",
							val: "4",
							label: "4 - Very Good",
						},
						{
							name: "q1_1",
							val: "5",
							label: "5 - Excellent",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q1_1") ? true : false}
				/>
			</div>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="1.2. How prepared did you feel to support your attendees throughout the event lifecycle?"
					reqd={true}
					data={[
						{
							name: "q1_2",
							val: "1",
							label: "1 - Poor",
						},
						{
							name: "q1_2",
							val: "2",
							label: "2 - Fair",
						},
						{
							name: "q1_2",
							val: "3",
							label: "3 - Good",
						},
						{
							name: "q1_2",
							val: "4",
							label: "4 - Very Good",
						},
						{
							name: "q1_2",
							val: "5",
							label: "5 - Excellent",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q1_2") ? true : false}
				/>
			</div>

			<div className="form-group one " style={{ marginTop: "15px" }}>
				<Input
					name="q1_3"
					label="1.3 What worked especially well from a dashboard user perspective?"
					reqd={true}
					value={""}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>
			</div>
		</>
	);
}
